var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:['alert-component', _vm.visible ? 'visible' : '', _vm.alert.priority]},[_c('h2',[_vm._v(_vm._s(_vm.alert.title))]),_vm._v(" "),(_vm.alert.description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.alert.description)}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"close",on:{"click":function($event){_vm.close()}}},[_c('icon',{attrs:{"name":"close"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11239763","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = DEPO
// module chunks = 15